import { T } from "@angular/cdk/keycodes";
import { TransectMesure } from "./transect-mesure";

export class Transect {
    Position: number;
    DistanceLimiteAval: number;
    DistanceRGZBZI: number;
    DistanceRDZBZI: number;
    DistanceRGZIAZINA: number;
    DistanceRDZIAZINA: number;
    DistanceRGZIZP: number;
    DistanceRDZIZP: number;
    Lm: number;
    Commentaire: string;

    TransectMesureList: TransectMesure[] = [];

    static mapFromJSON(json): Transect {
        const t = new Transect();

        t.Position = json.position;
        t.DistanceLimiteAval = json.distanceLimiteAval;
        t.DistanceRGZBZI = json.distanceRGZBZI;
        t.DistanceRDZBZI = json.distanceRDZBZI;
        t.DistanceRGZIAZINA = json.distanceRGZIAZINA;
        t.DistanceRDZIAZINA = json.distanceRDZIAZINA;
        t.DistanceRGZIZP = json.distanceRGZIZP;
        t.DistanceRDZIZP = json.distanceRDZIZP;
        t.Lm = json.lm;
        t.Commentaire = json.commentaire;
        if (json.transectMesureList) {
            t.TransectMesureList = json.transectMesureList.map(jsonItem => TransectMesure.mapFromJSON(jsonItem));
        }
        return t;
    }
}